import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TasksSolved from './components/TasksSolved';
import WhyGoodSpecialistsFail from './components/WhyGoodSpecialistsFail';
import ProgramContent from './components/ProgramContent';
import WhyMostTrainingsFail from './components/WhyMostTrainingsFail';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import SuitableFor from './components/SuitableFor';
import TrainingFormats from './components/TrainingFormats';
import CaseStudies from './components/CaseStudies';
import ProjectFlow from './components/ProjectFlow';
import CTASection from './components/CTASection';
import WhyAlexeySivko from './components/WhyAlexeySivko';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Программа', target: 'program' },
  { label: 'Кейсы', target: 'cases' },
  { label: 'Цены', target: 'contact' },
  { label: 'FAQ', target: 'faq' },
];

export default function ClientRelationsTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по работе с клиентами | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <TasksSolved />
        <WhyGoodSpecialistsFail />
        <ProgramContent />
        <WhyMostTrainingsFail />
        <WhyProgramsWork />
        <CompanyResults />
        <SuitableFor />
        <TrainingFormats />
        <CaseStudies />
        <ProjectFlow />
        <CTASection />
        <WhyAlexeySivko />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}